<script>
  import image from "../assets/logo.png";
</script>

<div class="bg-dark text-white">
  <nav class="navbar navbar-expand-lg navbar-dark bg-dark container">
    <a href="/" class="navbar-brand">
      <img src="/build/assets/{image}" width="30" height="30" class="d-inline-block align-top" alt="">
      Kalender Bali
    </a>
    <button
      class="navbar-toggler"
      type="button"
      data-toggle="collapse"
      data-target="#navbarSupportedContent"
      aria-controls="navbarSupportedContent"
      aria-expanded="false"
      aria-label="Toggle navigation"
    >
      <span class="navbar-toggler-icon"></span>
    </button>

    <div class="collapse navbar-collapse" id="navbarSupportedContent">
      <ul class="navbar-nav mr-auto">
        <li class="nav-item">
          <a href="/" class="nav-link">Home</a>
        </li>
        <li class="nav-item">
          <a href="/privacy-policy.html" class="nav-link">Privacy Policy</a>
        </li>
        <li class="nav-item">
          <a href="/data-deletion.html" class="nav-link">Data Deletion</a>
        </li>
      </ul>
    </div>
  </nav>
</div>
